import Cookies from 'js-cookie'

let CURRENT_PAGE_URL = window.location.href
const PAGES_TO_TRACK = ['/checkout/', '/order/', '/bnpl/', '/billie/', '/mondu/'] // all pages considered part of checking out
const PAGES_TO_IGNORE = ['/cart'] // pages that dont change the cookie status
const PAGES_THAT_CLEAR_COOKIE = ['/confirmation'] // pages that clear the tracking status
const COOKIE_PROPERTIES = { expires: 2 }

/**
 * Determines if user is on a checkout page and triggers Cookie checking
 * If on page that clears cookie = clear cookie
 * If tracking cookie is detected trigger dropout
 */
function initCheckoutTracking() {
    // if on page that shouldn't affect the cookie or trigger tracking
    if (pathIncludedInCheck(PAGES_TO_IGNORE)) {
        return
    }
    // if on page that clears the tracking Cookie
    if (pathIncludedInCheck(PAGES_THAT_CLEAR_COOKIE)) {
        clearCheckoutTrackingCookie()

        return
    }
    // if on page that sets the tracking Cookie
    if (pathIncludedInCheck(PAGES_TO_TRACK)) {
        checkIfCookiesEnabled()
        return
    }
    // if tracking Cookie detected = dropout
    if (Cookies?.get('oc-chcktrck')) {
        triggerCheckoutDropout()
    }
}

/**
 * Checks if user has loaded Cookies
 * 1 retry is attempted, afterwards we track that Cookies failed
 */
function checkIfCookiesEnabled() {
    if (!Cookies) return

    setCheckoutTrackingCookie()
}

/**
 * CURRENT_PAGE_URL is updated due to Vue router
 * Checks if the CURRENT_PAGE_URL matches any of the conditioned paths
 *
 * @param {Array} includesArray
 * @returns {boolean}
 */
function pathIncludedInCheck(includesArray) {
    let CURRENT_PAGE_URL = window.location.href
    return includesArray.some((path) => {
        return CURRENT_PAGE_URL.includes(path)
    })
}

/**
 * Sets the Cookie that will later trigger the segment event about leaving checkout
 * Sets Cookie with path where the exit happened
 */
function setCheckoutTrackingCookie() {
    Cookies.set('oc-chcktrck', 1, COOKIE_PROPERTIES)
    Cookies.set('oc-chcktrck-path', CURRENT_PAGE_URL, COOKIE_PROPERTIES)
}

/**
 * Clears the Cookie that tracks dropout
 */
function clearCheckoutTrackingCookie() {
    Cookies?.remove('oc-chcktrck')
}

/**
 * If user didn't reach thanks page or cart we assume its a dropout and we track this
 * Sets Cookie with counter to count how many dropouts per session happen
 */
function triggerCheckoutDropout() {
    const concurrentDropout = parseInt(Cookies?.get('oc-chcktrck-freq')) || 0
    const currentCount = concurrentDropout + 1

    Cookies.set('oc-chcktrck-freq', currentCount, COOKIE_PROPERTIES)

    trackToSegment('Checkout Dropout Detected', {
        exitFromPath: Cookies?.get('oc-chcktrck-path') || 'unknown',
        exitToPath: CURRENT_PAGE_URL,
        dropOutCountThisSession: currentCount,
    })

    clearCheckoutTrackingCookie()
}

/**
 * Does the actual tracking
 * Possible refactor = import segment/index.js and use track click??
 *
 * @param {string} eventName
 * @param {object} payload
 */
function trackToSegment(eventName, payload = {}) {
    window.analytics?.track(eventName, {
        category: 'Checkout',
        ...payload,
    })
}

// saved in window because vue router also needs to trigger the function sometimes
if (global.hasDelayedTracking) {
    window.addEventListener('client:initialized', () => {
        window.Store.initCheckoutTracking = initCheckoutTracking
        window.Store.initCheckoutTracking()
    })
} else {
    window.Store.initCheckoutTracking = initCheckoutTracking
    window.Store.initCheckoutTracking()
}
